export default function () {
  return {
    user: undefined,
    permissions: [],
    label: undefined,
  };
}
